import SecurityAccessories from "./SecurityAccessories";
import AccessoryDetail from "./AccessoryDetail";
import { ACCESSORY_PATHS } from "./accessories";

export { ACCESSORY_PATHS };

// The WZLTEG_1 gateway's accessories (app/screens/SecurityDevices.js and
// SecurityDeviceDetails.js). Both take the gateway's config device as
// location.state.data: open the list with
// history.push(ACCESSORY_PATHS.LIST, { data: device }); the list opens
// ACCESSORY_PATHS.DETAIL with { data, accessory, kind: "sensor" | "remote" }.
export const SECURITY_ACCESSORY_ROUTES = [
  { path: ACCESSORY_PATHS.LIST, component: SecurityAccessories },
  { path: ACCESSORY_PATHS.DETAIL, component: AccessoryDetail },
];

export { SecurityAccessories, AccessoryDetail };
